<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="handleEdit(edit, null)"
        >
          新增人员请假天数
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item  class="pr-10">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="关键词(匹配标题)"
            />
          </el-form-item>
          <el-form-item class="pr-10">
            <el-select
              v-model="queryForm.peopleId"
              placeholder="请选择员工"
              class="fix-width"
              clearable
            >
              <el-option
                v-for="item in staffList"
                :key="item.peopleId"
                :label="item.basic.name"
                :value="item.peopleId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  class="pr-10">
            <el-date-picker
              v-model="queryForm.year"
              type="year"
              placeholder="选择年份"
              value-format="YYYY"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column
        align="left"
        label="人员"
        prop="people.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="年份"
        prop="basic.year"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="总可请假天数"
        prop="basic.totalCount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="目前已请假天数"
        prop="basic.usedCount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="目前请假中天数"
        prop="basic.pendingCount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleEdit(edit, row)">
            编辑
          </el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { findVacationList, removeVacation } from '@/api/oa'
import Edit from './edit.vue'
import { reactive, ref, getCurrentInstance } from 'vue'
import commomFunction from '../common'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'OaVacationIndex',
  components: { Edit },
  setup() {
    const { proxy } = getCurrentInstance()
    const list = reactive([])
    const branchList = reactive([])
    const stepList = [
      {
        label: '已生效',
        value: 1,
      },
      {
        label: '待生效',
        value: 2,
      },
    ]
    const listLoading = ref(true)
    const layout = 'total, sizes, prev, pager, next, jumper'
    const total = ref(0)
    const { staffList } = commomFunction()
    const queryForm = reactive({
      page: 1,
      size: 10,
      peopleId: '',
      year: '',
      keyword: '',
    })
    const edit = ref(null)
    const fetchData = async () => {
      listLoading.value = true
      const { list: list1, total: total1 } = await findVacationList(
        queryForm
      )
      list.length = 0
      list.push(...list1)
      total.value = total1
      listLoading.value = false
    }
    const queryData = () => {
      queryForm.page = 1
      fetchData()
    }
    //添加和编辑
    const handleEdit = (edit, row) => {
      edit.showEdit(row)
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const handleDelete = (row) => {
      proxy.$baseConfirm(
        `你确定要删除人员请假天数吗`,
        null,
        async () => {
          await removeVacation({
            vacationId: row.vacationId,
          })
          proxy.$baseMessage(
            `删除人员请假天数成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          queryData()
        }
      )
    }
    //分页
    const handleSizeChange = (val) => {
      queryForm.size = val
      fetchData()
    }
    const handleCurrentChange = (val) => {
      queryForm.page = val
      fetchData()
    }
    getAllBranchList()
    //拉取数据
    queryData()
    return {
      list,
      listLoading,
      layout,
      total,
      queryForm,
      moment,
      edit,
      stepList,
      staffList,
      branchList,
      fetchData,
      queryData,
      handleEdit,
      handleDelete,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
